import { ApiKey, ApiPathManager } from "app/shared/services/api-path";
import store from "app/shared/store/store";
import { instance } from "app/shared/util/token-store";
import moment from "moment";
import { ParamCardRequest } from "../list-card/list-card.web";
import {
  FetchCardAuthorizationRequest,
  FetchCardHistoryRequest,
  FetchCardPhysicalRegisterRequest,
  FetchCardStatementRequest,
  FetchCardUpdateEComStatusRequest,
  FetchCardUpdateStatusRequest,
} from "../reducer/types";

export const fetchCardListService = async (cardType?: string) => {
  const { url } = ApiPathManager(ApiKey.GET_CARD_LIST);
  const cifNum = store.getState().account.USERPROFILE?.CIFNUMBER;
  const signature = store.getState().account.signature;
  const type = "&" + (cardType?.length ? cardType : "ALL");
  const response: any = await instance.get(url + "/" + cifNum + type, { headers: { token: signature } });
  return response;
};

export const fetchCardDetailService = async (cardID?: string) => {
  const { url } = ApiPathManager(ApiKey.GET_CARD_DETAIL);
  const signature = store.getState().account.signature;
  const response: any = await instance.get(url + "/" + cardID, { headers: { token: signature } });
  return response;
};

export const fetchCardActivateService = async (param?: ParamCardRequest) => {
  const { url } = ApiPathManager(ApiKey.CARD_ACTIVATE);
  const signature = store.getState().account.signature;
  const body = {
    cardId: param?.cardID,
    suffix: param?.suffix,
  };
  const response: any = await instance.post(url, body, { headers: { token: signature } });
  return response;
};

export const fetchCardUpdateStatusService = async (action: FetchCardUpdateStatusRequest) => {
  const { url } = ApiPathManager(ApiKey.CARD_UPDATE_STATUS);
  const signature = store.getState().account.signature;
  const body = {
    cardId: action.payload,
    termCardStatus: action.status,
  };
  const response: any = await instance.post(url, body, { headers: { token: signature } });
  return response;
};

export const fetchCardUpdateEComStatusService = async (action: FetchCardUpdateEComStatusRequest) => {
  const { url } = ApiPathManager(ApiKey.CARD_UPDATE_E_COM_STATUS);
  const signature = store.getState().account.signature;
  const body = {
    cardId: action.payload,
    ecomStatus: action.status,
  };
  const response: any = await instance.post(url, body, { headers: { token: signature } });
  return response;
};

export const fetchCardShowFullNumService = async (cardID?: string) => {
  const { url } = ApiPathManager(ApiKey.CARD_SHOW_FULL_NUM);
  const signature = store.getState().account.signature;
  const body = {
    cardId: cardID,
  };
  const response: any = await instance.post(url, body, { headers: { token: signature } });
  return response;
};

export const fetchCardHistoryService = async (action: FetchCardHistoryRequest) => {
  const { url } = ApiPathManager(ApiKey.CARD_HISTORY);
  const signature = store.getState().account.signature;
  const fromDate = moment(action.payload?.fromDate, "DD/MM/YYYY").format("DDMMYYYY");
  const toDate = moment(action.payload?.toDate, "DD/MM/YYYY").format("DDMMYYYY");
  const params = "cardId=" + action.payload?.cardID + "&fromDate=" + fromDate + "&toDate=" + toDate;
  const response: any = await instance.get(url + "?" + params, { headers: { token: signature } });
  return response;
};

export const fetchCardStatementService = async (action: FetchCardStatementRequest) => {
  const { url } = ApiPathManager(ApiKey.CARD_STATEMENT);
  const signature = store.getState().account.signature;
  const response: any = await instance.get(url + "/" + action.payload, { headers: { token: signature } });
  return response;
};

export const fetchCardPhysicalRegisterService = async (action: FetchCardPhysicalRegisterRequest) => {
  const { url } = ApiPathManager(ApiKey.CARD_PHYSICAL_REGISTER);
  const signature = store.getState().account.signature;
  const body = {
    fullname: action.payload?.fullName,
    phoneNum: action.payload?.phoneNum,
    email: action.payload?.email || "",
    officeAddress: action.payload?.officeAddress || "",
    cardType: action.payload?.cardType,
  };
  const response: any = await instance.post(url, body, { headers: { token: signature } });
  return response;
};

const authParam = (action?: FetchCardAuthorizationRequest) => {
  const params = {
    requestId: action?.payload?.requestId,
    otpTransId: action?.payload?.otpTransId,
    otpCode: action?.code,
  };
  return params;
};

export const fetchCardAuthorizationService = async (actionRq: FetchCardAuthorizationRequest) => {
  const { url } = ApiPathManager(ApiKey.PAYMENT_CARD_AUTH);
  const signature = store.getState().account.signature;
  const body = authParam(actionRq);
  console.log("body: ", body);
  const response: any = await instance.post(url, body, { headers: { token: signature } });
  return response;
};
